"use client";

import { Button, Input } from "klikoo-web-uikit";
import Image from "next/image";
import { Carousel as ReactCarousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import { IMAGE1, IMAGE2, IMAGE3 } from "@/domains/login/constants/base64";
import { useValidateLogin } from "@/domains/login/hooks/validation/useValidateLogin";
import { useLogin } from "@/domains/login/query/useLogin";
import Link from "next/link";

export default function LoginPage() {
  const { formState, register, handleSubmit, getValues } = useValidateLogin();
  const { mutate, isPending } = useLogin();

  const onSubmit = () => {
    mutate({ email: getValues("email"), password: getValues("password") });
  };

  return (
    <div className="flex h-screen w-screen relative">
      <div className="md:w-[52%] lg:w-[50%] xl:w-[50%] 2xl:w-[50%] h-screen relative">
        <ReactCarousel
          autoPlay
          className="w-full relative"
          showThumbs={false}
          infiniteLoop
        >
          <Image
            src="https://pvpapi.stage.pvg.im/klikoo-document/file//66e1da92-81a9-4f2b-a879-79e9e2b33de7"
            alt=""
            fill
            priority
            placeholder="blur"
            blurDataURL={IMAGE1}
            className="object-[30%_30%] object-cover"
          />
          <Image
            src="https://pvpapi.stage.pvg.im/klikoo-document/file//539fccdd-cf94-4350-b660-f1d82e95325c"
            alt=""
            fill
            priority
            placeholder="blur"
            blurDataURL={IMAGE2}
            className="object-[30%_30%] object-cover"
          />
          <Image
            src="https://pvpapi.stage.pvg.im/klikoo-document/file//be4e3763-41df-4826-94eb-da4079b3e0c5"
            alt=""
            fill
            priority
            placeholder="blur"
            blurDataURL={IMAGE3}
            className="object-[30%_30%] object-cover"
          />
        </ReactCarousel>
      </div>
      <div className="flex flex-col items-center justify-center mx-auto md:mx-0 md:w-[48%] lg:w-[50%] xl:w-[50%] 2xl:w-[50%] h-screen overflow-auto bg-white z-50">
        <div className="flex flex-col w-4/5 lg:w-[calc(100%/8*5)]">
          <div className="min-w-1/2 w-full mx-auto">
            <div className="flex gap-4 items-center">
              <div className="relative w-[92px] h-[40px]">
                <Image
                  fill
                  src="https://pvpapi.stage.pvg.im/klikoo-document/file//de7adf89-5f51-4db3-b98b-9ece3eee4f84"
                  alt="Logo Klikoo"
                />
              </div>
            </div>
          </div>

          <p className="text-[40px] font-bold text-black mt-8 mb-4 text-left">
            Login
          </p>
          <p className="text-[#202020] opacity-75 mb-8">
            Masuk untuk mengakses akun Anda
          </p>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-full flex flex-col justify-center"
          >
            <div className="flex flex-col gap-2 mb-6">
              <p>Email</p>
              <Input placeholder="Masukkan email" {...register("email")} />
              {formState.errors.email && (
                <p className="text-danger-main">
                  {formState.errors.email?.message}
                </p>
              )}
            </div>
            <div className="flex flex-col gap-2 mb-6">
              <p>Kata sandi</p>
              <Input
                placeholder="Masukkan kata sandi"
                password
                {...register("password")}
              />
              {formState.errors.password && (
                <p className="text-danger-main">
                  {formState.errors.password?.message}
                </p>
              )}
            </div>
            {/* <Link
              href="/forgot-password"
              className="text-primary-main font-semibold text-right"
            >
              Lupa kata sandi?
            </Link> */}
            <Button type="submit" className="mt-6" loading={isPending}>
              Masuk
            </Button>
          </form>
          <p className="text-sm mt-6 mx-auto">
            Belum memiliki akun?{" "}
            <Link
              href="/registration"
              className="text-primary-main underline cursor-pointer"
            >
              Buat Akun
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
